/**
 *  @class
 *  @function TruncateText
 */
if (!customElements.get('truncate-text')) {
  class TruncateText extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.truncatedContent = this.querySelector('[data-truncated-content]');
      this.fullContent = this.querySelector('[data-full-content]');
      this.toggles = this.querySelectorAll('[data-truncated-button]');

      if (!this.truncatedContent || !this.fullContent || !this.toggles.length) return;

      this.toggles.forEach((toggle) => {
        toggle.addEventListener('click', this.toggleTruncatedContent.bind(this));
      })
    }
    
    toggleTruncatedContent() {
      this.truncatedContent.classList.toggle('hide');
      this.fullContent.classList.toggle('hide');
    }
  }
  customElements.define('truncate-text', TruncateText);
}

/**
 *  @class
 *  @function FloatingBar
 */

if ( typeof FloatingBar !== 'function' ) {
  class FloatingBar extends HTMLElement {
    constructor() {
      super();
      this.threshold = 0;
      this.type = this.getAttribute('data-floating-bar-type');
      this.addToCartButton = document.querySelector('[action="/cart/add"] [name="add"]');
      this.init();
    }
    init() {
      this.classList.add('has-loaded');
      window.addEventListener('resize', this.configureThreshold.bind(this));
      window.addEventListener('scroll', this.configureVisibility.bind(this));
    }
    configureThreshold() {
      if (this.type === 'product' && this.addToCartButton) {
        this.threshold = this.addToCartButton.offsetTop;
      } else this.threshold = this.offsetTop;
    }
    configureVisibility() {
      // show when scrolled into view
      if (window.scrollY >= this.threshold) {
        this.classList.add('is-visible');
      } else {
        this.classList.remove('is-visible');
      }
    }
  }
  if ( typeof customElements.get('floating-bar') == 'undefined' ) {
		customElements.define('floating-bar', FloatingBar);
	}
}
